<template lang="pug">
.robo-report(:class="{ shown: roboReportShown && chartShown, half: watchlistShown && watchlistThemesShown, minimized: roboReportMinimized }")
  .close(@click="close", title="close robo report")
  .ref-pub-opener(v-if="reportCardPub",
                  @click="toggleReportCard",
                  :title="`open ${ reportCardPub.n } report card`") report card
    .bg(:style="{ 'background-image': `url('${ reportCardPub.i }'` }")
  //.ref-pub-opener(v-if="refPubInfo",
  //                @click="refPubInfoShown = !refPubInfoShown;",
  //                :title="`open ${ refPubInfo.n } report card`") report card
  //  .bg(:style="{ 'background-image': `url('${ refPubInfo.i }'` }")
  .minimize(@click="roboReportMinimized = true", title="minimize robo report")
  .unminimize(@click="roboReportMinimized = false", title="restore robo report")
  //.opener(@click="roboReportShown = true") view robo report
  global-events(@keyup.stop.esc="close")
  .top
    .heading {{ watchlistThemesParentFilter === 'ESG themes' && 'esg' || 'robo' }} report
      .custom(v-if="watchlistShown", @click="watchlistThemesShown = ! watchlistThemesShown", :class="{ on: !watchlistThemesShown }") auto-gen
    .publishers(:class="{ shown: watchlistShown && watchlistThemesShown, 'has-selection': Object.keys(selectedWatchlistPublishers || {}).length, 'has-overflow': 1 || Object.keys(selectedWatchlistPublishers || {}).length > 6 }")
      .publisher(v-for="({ n, i }, key) in publishers",
                 :key="key",
                 :title="n",
                 @click="toggleSelectedWatchlistPublisher(key)",
                 :class="{ on: publisherSelected(key) }")
        .bg(v-lazy:background-image="i")
      .title(@click="selectedWatchlistPublishers = {}", :resetable="!!Object.keys(selectedWatchlistPublishers || {}).length") publishers:
    .doc-types(:class="{ shown: watchlistShown && watchlistThemesShown, 'has-selection': Object.keys(selectedWatchlistDocTypes || {}).length }",
               :count="Object.keys(selectedWatchlistDocTypes || {}).length")
      .doc-type(v-for="(title, key) in watchlistDocTypes",
                 :key="key",
                 :title="title",
                 @click="toggleSelectedWatchlistDocType(key)",
                 :class="{ on: docTypeSelected(key) }") {{ title }}
      .title(@click="selectedWatchlistDocTypes = {}", :resetable="!!Object.keys(selectedWatchlistDocTypes || {}).length") documents:
        //.bg(v-lazy:background-image="i")
    .blocker
    .times(ref="times",
           :class="{ shown: watchlistShown && watchlistThemesShown }",
           @mousemove="closest",
           @mouseup="moving = null")
      .title(@click="setTimes('14.4', '21.2')", :resetable="roboReportStartTime !== times[0] || roboReportEndTime !== times[times.length - 1]") quarters:
      .range(:style="{ left: nudgeStart && `${ nudgeStart }px` || '0', right: nudgeEnd && `${ nudgeEnd }px` || '0' }")
        .start(@mousedown="moving = 'start'",
               :class="{ on: moving === 'start' }",
               :start="roboReportStartTime && qLabel(roboReportStartTime || '').replace(/(\\d\\d)Q1|\\d\\d(Q[234])/g, '$1$2').replace(/(\\d\\d)/, '20$1')")
        .end(@mousedown="moving = 'end'",
             :class="{ on: moving === 'end' }",
             :start="roboReportEndTime && qLabel(roboReportEndTime || '').replace(/(\\d\\d)Q1|\\d\\d(Q[234])/g, '$1$2').replace(/(\\d\\d)/, '20$1')")
      .time(v-for="time in times",
            :key="time",
            :id="time",
            :class="{ skinny: /[2-4]$/.test(time) }") {{ qLabel(time).replace(/(\d\d)Q1|\d\d(Q[234])/g, '$1$2').replace(/(\d\d)/, '20$1').replace(/Q[2-4]/, '.') }}
      .links
        .link(:style="{ right: '11.0125rem' }", @click="setTimes('19.2', '21.2')")
          .label last two years
        .link(:style="{ right: '5.8rem' }", @click="setTimes('20.2', '21.2')")
          .label last year
        .link(:style="{ right: '4.55rem' }", @click="setTimes('20.4', '21.2')")
          .label last two quarters
        .link(:style="{ right: '3.95rem' }", @click="setTimes('21.1', '21.2')")
          .label last quarter
  .no-report(v-if="!defaultRoboReportUrl || roboReportUrl === defaultRoboReportUrl") select themes or filters to load report
  .list(v-else-if="roboReport")
    .items(v-if="items && itemsLength")
      a.item-wrap(v-for="({ k, pg, did, fn, pu, md, kw }, index) in items",
                  :key="`${ did }|${ pg }|${ k }`"
                  target="_blank",
                  :href="`/?f=${ fn };did=${ did };pg=${ pg }`",
                  NOTclick.self="toPDF({ folderName: fn, id: did, pg })",
                  :title="`Open page ${ pg } in new tab`")
        //-.item(v-observe-visibility="{ once: true, callback: isVisible => isVisible && (textVisible[`${ did }|${ pg }|${ k }`] = true) }")
        .item
          .publisher(@click.stop.prevent.capture="itemPubClick(pu)", :title="`filter by ${ publishers[pu].n }`")
            .bg(v-lazy:background-image="`https://content.weave.ai/picture-images/${ pu }-logo.jpg`")
            //.bg(:v-lazy-background-image="`https://content.weave.ai/picture-images/${ pu }-logo.jpg`" :style="{ 'background-image': `url('https://content.weave.ai/picture-images/${ pu }-logo.jpg')` }")
          .date  {{ date(md) | moment('from', 'now') }}
          .document
            .bg(v-lazy:background-image="`https://d23xtmsrsmj88h.cloudfront.net/picture-images/${ did }-1.png`")
          //-.text(v-if="textVisible[`${ did }|${ pg }|${ k }`] && keywords && keywords.length")
          //-.text(v-if="keywords && keywords.length")
          .text(v-if="(kw || keywords) && (kw.split('|').length || keywords.length)")
            highlighter(:text-to-highlight="k",
                        :case-sensitive="true",
                        highlight-class-name="keyword",
                        highlight-tag="span",
                        @click="toPDF({ folderName: fn, id: did, pg })",
                        :search-words="(kw && kw.split('|')) || keywords")
          .text(v-else) {{ k }}
          //-.text(v-else) {{ k }}
          clipboard(:id="`ic|${ did }|${ pg }|${ index }`",
                    :text="k",
                    :url="`/?f=${ fn };did=${ did };pg=${ pg }`",
                    :date="date(md) | moment('MMM Do, YYYY')",
                    :pub="(publishers[pu] || engage.publisher).n",
                    :index="index")
  theme-picker(v-if="watchlist")
  //-.vis-types
  //-  .outline(:class="{ [selectedVis || 'topThemes']: true }")
  //-  .vis-type(@click="Object.keys(selectedThemes || {}).length && (selectedVis = 'selectedThemes')", :class="{ clickable: themes && themes.length, on: selectedVis === 'selectedThemes' }") selected
  //-  .vis-type(@click="selectedVis = 'topThemes'", :class="{ on: !selectedVis || selectedVis === 'topThemes' }") trending
  //-.themes(v-if="themes && themes.length")
  //-  global-events(v-if="selectedParentTheme", @keyup.stop.esc="selectedParentTheme = null")
  //-  .theme(v-for="{ t, n, th } in themes",
  //-         :key="n",
  //-         :title="selectedVis === 'selectedThemes' && `Deselect ${ t || n }` || ''",
  //-         :class="{ on: selectedVis !== 'selectedThemes' && selectedParentTheme === n, dim: selectedVis !== 'selectedThemes' && selectedParentTheme && (selectedParentTheme !== n) && $store.getters.themes[selectedParentTheme] }"
  //-         @mouseenter="!selectedParentTheme && (hoverTheme = n)",
  //-         @mouseleave="hoverTheme = null",
  //-         @click="themeClick(n)")
  //-    .details
  //-      .close(v-if="selectedVis === 'selectedThemes'") &times;
  //-      .label.top {{ t || n }}
  //-      .label {{ t || n }}
  //-      .bg(v-if="th" :style="{ 'background-image': beenShown && `url('${ th && th.url }')` }")
  //-.top
  //-  .bar
  //-    //-todo: adjust position sticky to account for this now being present
  //-    .favicons(v-if="true || Object.keys(publishers || {}).length > 1")
  //-      .favicon(v-for="({ n, i }, key) in publishers",
  //-        @mouseenter="hoverPub = key",
  //-        @mouseleave="hoverPub = null",
  //-        @click="referencePub = referencePub !== key && key || null",
  //-        :class="{ dim: referencePub && referencePub !== key }",
  //-        :key="key",
  //-        :title="`click to ${ referencePub === key && 'un' || '' }set ${ n } as reference publisher`"
  //-        :style="{ 'background-image': `url('${ i }')` }")
  //-        .label {{ n }}
  //-    .leadingTrailing(:class="{ hide: !referencePub }")
  //-      .leading(@click="leadingTrailing = true", :class="{ selected: leadingTrailing }") leading
  //-      .trailing(@click="leadingTrailing = false", :class="{ selected: !leadingTrailing }") trailing
  //-  .times
  //-    .title quarters:
  //-    .time(v-for="time in times",
  //-          @mouseenter="hoverTime = time",
  //-          @mouseleave="hoverTime = null",
  //-          :key="time",
  //-          :class="{ on: hoverTime === time }") {{ qLabel(time).replace(/(\d\d)Q1|\d\d(Q[234])/g, '$1$2').replace(/(\d\d)/, '20$1') }}
  //-.groups
  //-  .group(v-if="themes && themes.length", :class="{ 'has-pin': !!hoverTheme }")
  //-    .by-theme(v-for="{ t, n, th } in childThemes || themes",
  //-              :key="n",
  //-              :class="{ 'has-hover': !!hoverPub, pin: hoverTheme === n }")
  //-      .top
  //-        .title(@click="selectedVis !== 'selectedThemes' && !(childThemes && childThemes.length) &&  themeClick(n)",
  //-               :class="{ clickable: selectedVis !== 'selectedThemes' && !(childThemes && childThemes.length) }") {{ t || n }}
  //-      .rows
  //-        .row(v-for="({ wt }, key) in mergedWeights(n)",
  //-             :class="{ on: key === hoverPub }",
  //-             :key="key",
  //-             :rank="rspRank(n, key)",
  //-             :style="{ order: rspRank(n, key) + 1 }",
  //-             :title="publishers[key] && publishers[key].n")
  //-          .favicon(:class="{ [key]: true }",
  //-                   v-if="publishers[key]",
  //-                   :title="totalRsps(wt)",
  //-                   :style="{ transform: `translate3d(${ weight(lastValue(wt)) }, 0, 0)`, 'background-image': `url('${ publishers[key] && publishers[key].i }')` }")
  //-            .label {{ publishers[key] && publishers[key].n }}
  //-          .dashes(:style="{ transform: `translate3d(${ weight(lastValue(wt)) }, 0, 0)` }")
  //-          .history
  //-            .past(v-for="({ rs: value, rsp }, time) in wt",
  //-                  :key="time",
  //-                  @mouseenter="hoverTime = time",
  //-                  @mouseleave="hoverTime = null",
  //-                  :class="{ on: hoverTime === time }",
  //-                  :rsp="quantile(rsp)",
  //-                  :title="title(time)",
  //-                  :style="{ transform: `translate3d(${ weight(value) }, 0, 0) scale(${ hoverTime === time && 1.5 || 1 })` }") {{ qLabel(time) }}
  //-robo-report(v-if="roboReportBeenShown")
  //-  //-.group(v-if="topThemes && topThemes.length&& (!selectedVis || selectedVis === 'topThemes')", :class="{ 'has-pin': !!hoverTheme }")
  //-  //-  .by-theme(v-for="{ t, n, th } in topThemes",
  //-  //-            :key="n",
  //-  //-            :class="{ 'has-hover': !!hoverPub, pin: hoverTheme === n }")
  //-  //-    .top
  //-  //-      .title {{ t }}
  //-  //-    .rows
  //-  //-      .row(v-for="({ wt }, key) in mergedWeights(n)",
  //-  //-           :class="{ on: key === hoverPub }",
  //-  //-           :key="key",
  //-  //-           :rank="rspRank(n, key)",
  //-  //-           :style="{ order: rspRank(n, key) + 1 }",
  //-  //-           :title="publishers[key] && publishers[key].n")
  //-  //-        .favicon(:class="{ [key]: true }",
  //-  //-                 :title="totalRsps(wt)",
  //-  //-                 :style="{ transform: `translate3d(${ weight(lastValue(wt)) }, 0, 0)`, 'background-image': `url('${ publishers[key] && publishers[key].i }')` }")
  //-  //-          .label {{ publishers[key] && publishers[key].n }}
  //-  //-        .history
  //-  //-          .past(v-for="({ rs: value, rsp }, time) in wt",
  //-  //-                :key="time",
  //-  //-                @mouseenter="hoverTime = time",
  //-  //-                @mouseleave="hoverTime = null",
  //-  //-                :class="{ on: hoverTime === time }",
  //-  //-                :rsp="quantile(rsp)",
  //-  //-                :title="title(time)",
  //-  //-                :style="{ transform: `translate3d(${ weight(value) }, 0, 0) scale(${ hoverTime === time && 1.5 || 1 })` }") {{ qLabel(time) }}
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { vuexComputed } from '@/helpers';
import highlighter from 'vue-highlight-words';
import clipboard from '@/components/clipboard';
let navToPageTimer;
let loadTimer;
export default {
  name: 'roboReport',
  data() {
    return { lefts: null, rights: null, offset: 0, offsetRight: 0, moving: null, textVisible: {}, defaultReport: null };
  },
  watch: {
    roboReportShown(newValue) {
      const { roboReport, loadRoboReport, topThemes } = this;
      if (newValue && !roboReport) {
        console.log('topThemes', topThemes);
        loadRoboReport();
      }
      if (!newValue) {
        this.roboReportLaunchedFromWatchList = false;
      }
    },
    roboReportStartTime() {
      this.refresh();
    },
    roboReportEndTime() {
      this.refresh();
    },
    selectedWatchlistPublishers() {
      this.refresh();
    },
    selectedWatchlistDocTypes() {
      this.refresh();
    },
    roboReportUrl(newValue, oldValue) {
      const defaultUrl = this.defaultRoboReportUrl || oldValue;
      this.defaultRoboReportUrl = defaultUrl;
      if (newValue === defaultUrl) {
        this.roboReport = null;
      }
    }
  },
  computed: {
    ...mapGetters([
      'roboReportUrl',
      'watchlist',
      'themesWithAliases',
      'watchlistSelectedThemesWithAliases',
      'publishers',
      //'selectedWatchlistPublishers',
      // 'selectedWatchlistDocTypes',
      'watchlistDocTypes',
      'watchlistThemesParentFilter',
      'refPubInfo'
    ]),
    ...vuexComputed(
      'analytics',
      'topParentThemes',
      'selectedParentTheme',
      'childThemes',
      'referencePub',
      'leadingTrailing',
      'watchlistShown',
      'chartShown',
      'notificationsShown',
      'roboReport',
      'defaultRoboReportUrl',
      'roboReportShown',
      'roboReportMinimized',
      'roboReportLaunchedFromWatchList',
      'roboWeaveShown',
      'watchlistThemesShown',
      'roboReportStartTime',
      'roboReportEndTime',
      'roboReportThemesSize',
      'folderDoco',
      'insightsDoco',
      'pdf',
      'selectedWatchlistPublishers',
      'selectedWatchlistDocTypes',
      'refPubInfoShown',
      'watchlistThemesRefPub'
    ),
    reportCardPub() {
      const { refPubInfo, publishers } = this;
      const keys = Object.keys(publishers);
      return refPubInfo || { ...publishers[keys[0]], key: keys[0] };
    },
    nudgeStart() {
      //console.log('lefts are', this.lefts, this.lefts?.['15.3']);
      const { roboReportStartTime, lefts } = this;
      return lefts?.[roboReportStartTime] || 0;
    },
    nudgeEnd() {
      //console.log('rights are', this.rights, this.rights?.[18.1]);
      const { roboReportEndTime, rights } = this;
      return rights?.[roboReportEndTime] || 0;
    },
    themes() {
      const { topParentThemes, $store: { getters: { themes } } } = this;
      // console.log('computed themes', topParentThemes, (selectedVis === 'selectedThemes' && Object.keys(selectedThemes) || topParentThemes)
      //   .filter(n => themes[n])
      //   .map(n => themes[n]));
      return (topParentThemes.map(([n]) => n))
        .filter(n => themes[n])
        .map(n => themes[n]);
    },
    topThemes() {
      const { topParentThemes, roboReportThemesSize, $store: { getters: { themes } } } = this;
      return topParentThemes
        .filter(([n]) => themes[n])
        .filter((n, i) => i < roboReportThemesSize)
        .map(([n]) => themes[n]);
    },
    times() {
      // todo: make dynamic
      return [
        '14.4',
        '15.1', '15.2', '15.3', '15.4',
        '16.1', '16.2', '16.3', '16.4',
        '17.1', '17.2', '17.3', '17.4',
        '18.1', '18.2', '18.3', '18.4',
        '19.1', '19.2', '19.3', '19.4',
        '20.1', '20.2', '20.3', '20.4',
        '21.1', '21.2'
      ];
    },
    keywords() {
      //return ['\\bthe\\b', '\\ba\\b', '\\bis\\b', '\\bin\\b', '\\bon\\b', '\\bto\\b'];
      // todo: figure a way to optimize this, current perf is unacceptable
      //console.log('this.themesWithAliases', this.themesWithAliases);
      // return this.themesWithAliases.length > 1500 && [] || this.themesWithAliases?.map(escapeRegExpAndBound); // .filter((w, i) => i < 3500);
      return this.watchlistSelectedThemesWithAliases.length > 2300 && [] || this.watchlistSelectedThemesWithAliases?.map(escapeRegExpAndBound); // .filter((w, i) => i < 3500);
      function escapeRegExpAndBound(s) {
        return `\\b${ escapeRegExp(s) }\\b`; // $& means the whole matched string
      }
      function escapeRegExp(s) {
        return `${ s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') }`;
      }
    },
    publishers() {
      console.log('pubs', this.$store.getters.publishers);
      return this.$store.getters?.publishers || {
        ...this.$store.getters.publishers,
        total: {
          n: 'Total',
          i: 'https://www.total.com/themes/custom/total_com/dist/img/favicon.png'
        },
        bp: {
          n: 'Bp',
          i: 'https://www.bp.com/etc/designs/refresh/bp/favicon.ico'
        },
        chevron: {
          n: 'Chevron',
          i: 'https://www.chevron.com/assets/fav/favicon.ico?v=7k4MjPGMX6'
        },
        shell: {
          n: 'Shell',
          i:
            'https://www.shell.com/apps/settings/wcm/designs/shell-rio/clientlibs/themes/theme-shell/resources/favicon/favicon.ico'
        },
        exxon: {
          n: 'Exxon',
          i: 'https://corporate.exxonmobil.com/-/media/Global/Icons/XX-favicon.ico'
        },
        aramco: {
          n: 'Aramco',
          i: 'https://americas.aramco.com/images/favicon/favicon.ico'
        },
        cnpc: {
          n: 'China National Petroleum Corporation',
          i: 'https://www.cnpc.com.cn/favicon.ico'
        }
      };
    },
    items() {
      return this?.roboReport?.insights || [];
    },
    itemsLength() {
      return this?.items.length;
    }
  },
  methods: {
    ...mapActions([
      'loadRoboReport',
      'loadInsights',
      'loadDoco',
      'loadFolder',
      'toggleSelectedWatchlistPublisher',
      'toggleSelectedWatchlistDocType'
    ]),
    async toggleReportCard() {
      const { refPubInfoShown, watchlistThemesRefPub, reportCardPub: { key } } = this;
      if (!watchlistThemesRefPub) {
        await (this.watchlistThemesRefPub = key);
      }
      this.refPubInfoShown = !refPubInfoShown;
    },
    close() {
      const { roboReportLaunchedFromWatchList } = this;
      if (roboReportLaunchedFromWatchList) {
        this.chartShown = false;
      }
      this.roboReportShown = false;
    },
    async setTimes(start, end) {
      await (this.roboReportEndTime = end);
      await (this.roboReportStartTime = start);
    },
    refresh() {
      clearTimeout(loadTimer);
      loadTimer = setTimeout(() => this.loadRoboReport('custom'), 1700);
    },
    publisherSelected(publisher) {
      const { selectedWatchlistPublishers } = this;
      const length = Object.keys(selectedWatchlistPublishers).length;
      return !length || selectedWatchlistPublishers[publisher];
    },
    docTypeSelected(docType) {
      const { selectedWatchlistDocTypes } = this;
      const length = Object.keys(selectedWatchlistDocTypes).length;
      return !length || selectedWatchlistDocTypes[docType];
    },
    date(d) {
      return new Date(d);
    },
    closest({ clientX }) {
      const { moving } = this;
      if (moving) {
        const { lefts, rights, offset, offsetRight } = this;
        const start = moving === 'start';
        //const referenceOffset = start && offset || offsetRight;
        const x = start && (clientX - (offset + 96)) || offsetRight - clientX;
        const targets = Object.entries(start && lefts || rights || {});
        const deltas = targets.map(([key, edge]) => [key, Math.abs(x - edge)]);
        const [min] = deltas.sort((a, b) => a[1] - b[1]);
        this[start && 'roboReportStartTime' || 'roboReportEndTime'] = min[0];
        //console.log('clientX', clientX, min);
      }
    },
    async toPDF({ id, folderName, pg }) {
      console.log('use pg to page pdf', id, folderName, pg);
      return;
      await this.openFolder({ id, folderName });
      clearTimeout(navToPageTimer);
      navToPageTimer = setTimeout(() => {
        this.pdf = this.pdf.replace(/(?:\-\d+)?.pdf/, `-${ pg }.pdf`);
        window.scrollBy({ behavior: 'smooth', top: document.querySelector('.analysis .viewer').getBoundingClientRect().top - 50 });
      }, 500);

    },
    async openFolder({ id, folderName }) {
      // open folder
      console.log('openFolder from robo report', folderName);
      await this.loadInsights({ id });
      //this.loadFolder(folderName);
      this.watchlistShown = this.chartShown = this.roboWeaveShown = this.notificationsShown = false;
      // open doc
      console.log('openFolder openInsights', id);
      //this.doco = id;
      this.folderDoco = id;
      this.insightsDoco = id;
      //await (this.backToRobo = true);
      await this.loadDoco(id);
      await this.loadFolder(folderName);
      console.log('folderName', folderName);
      //await this.$store.dispatch('docoInsights', insights);
      // todo: fix for pdf not loading
      //this.insightsShown = true;
      //this.loadDoco(id);
      //this.pdf = `https://d23xtmsrsmj88h.cloudfront.net/documents/${ id || 'no did' }-1.pdf`;
      console.log('openFolder done', id);
      window.history.pushState({ fromRobo: true }, 'Weave - folder view');
      console.log('state added from robo report');
    },
    themeClick(n) {
      const { selectedVis, toggleTheme, selectedParentTheme, $store: { getters: { themes } } } = this;
      if (selectedVis === 'selectedThemes') {
        toggleTheme(n);
      } else {
        this.selectedParentTheme = (selectedParentTheme !== n && isParentTheme(n) && n) || null;
      }
      this.hoverTheme = null;
      function isParentTheme(n) {
        return !!themes[n]?.cth?.length;
      }
    },
    lastValue(wt = {}) {
      const values = Object.values(wt);
      return values[values.length - 1]?.rs;
    },
    mergedWeights(theme) {
      const { $store: { getters: { analytics } } } = this;
      //console.log('mergedWeights', theme, (analytics?.thd?.tht || {})[theme]?.pwt || 'not here');
      return ((analytics?.thd?.tht || {})[theme] || {}).pwt || {};
    },
    weight(value) {
      return `calc(${ value * 100 }vw - 10rem)`;
    },
    quantile(value) {
      return value <= 0.2 && 'one'
        || value <= 0.4 && 'two'
        || value <= 0.6 && 'three'
        || value <= 0.8 && 'four'
        || 'five';
    },
    sortedRsps(theme) {
      const { mergedWeights, totalRsps } = this;
      //console.log('mergedWeights', theme, mergedWeights(theme));//, Object.values(mergedWeights(theme)).map(({ wt }) => totalRsps(wt)));
      return Object.entries(mergedWeights(theme))
        .map(([key, { wt }]) => ({ key, total: totalRsps(wt) }))
        .sort((a, b) => {
          return b.total - a.total;
        });
    },
    totalRsps(wt) {
      return Object.values(wt).reduce((total, { rsp }) => total + rsp * 1, 0);
    },
    rspRank(theme, key) {
      const { sortedRsps } = this;
      //console.log('rspRank', theme, key, sortedRsps(theme));
      return sortedRsps(theme)?.findIndex(item => item.key == key);
    },
    random(value) {
      return (Math.random() * value).toPrecision(4) * 1;
    },
    //past(value) {
    //  const labels = ['2018-Q3', '2018-Q4', '2019', '2019-Q2', '2019-Q3', '2019-Q4', '2020', '2020-Q2'];
    //  const r = Array.from(new Array(8), n => this.random(value))
    //  .sort()
    //  .reduce((all, wt, i) => {
    //    all.push({ time: labels[i], value: wt });
    //    return all;
    //  }, []);
    //  console.log(value, r.map(v => JSON.stringify(v)).join(','));
    //  return r;
    //},
    qLabel(time) {
      return time?.replace?.(/\./, 'Q') || '';
      //return time.replace(/^.+\-/, '');
    },
    title(time) {
      return time?.replace?.(/-/, ' ') || '';
    },
    itemPubClick(key) {
      console.log('robo itemPubClick', key, this.selectedWatchlistPublishers);
      this.selectedWatchlistPublishers = { [key]: true };
    }
  },
  components: {
    highlighter,
    clipboard,
    themePicker: () => import('@/components/topo-components/theme-picker')
  },
  mounted() {
    const { roboReport, loadRoboReport, topThemes, watchlistThemesShown, $refs: { times } } = this;
    if (!roboReport && !watchlistThemesShown) {
      //console.log('topThemes', topThemes);
      loadRoboReport();
    }
    const box = times.getBoundingClientRect();
    const offset = box.left;
    const offsetRight = offset + box.width;
    const lefts = {};
    const rights = {};
    times.querySelectorAll('.time').forEach(element => {
      const time = element.getAttribute('id');
      const { left, width } = element.getBoundingClientRect();
      //console.log('{ left, width }', time, left, width);
      const adjusted = left - (offset + 96); //6rem
      lefts[time] = adjusted;
      rights[time] = offsetRight - left - width;
    });
    this.offset = offset;
    this.offsetRight = offsetRight;
    this.lefts = Object.freeze(lefts);
    this.rights = Object.freeze(rights);
    // console.log('rights', this.rights);
  }
};
</script>
<style scoped lang="scss">
@import '../../scss/global';
.robo-report {
  position: fixed;
  top: 4.4rem;
  bottom: 0;
  width: 100vw;
  overflow: auto;
  background-color: white;
  z-index: 16002;
  pointer-events: none;
  //padding: 0.5rem;
  opacity: 0;
  transition: all 250ms ease-in-out;
  //will-change: opacity;
  &.shown {
    opacity: 1;
    pointer-events: all;
  }
  &.minimized {
    transform: translate3d(0, -90vh, 0);
  }
  &.half {
    & > .list {
      width: 50%;
      .items {
        grid-template-columns: repeat(2, 1fr);
        & > .item-wrap {
          max-width: 22vw;
        }
      }
    }
    .no-report {
      position: absolute;
      top: 50%;
      left: 25%;
      color: #8f8f8f;
      font-size: 1rem;
      transform: translate3d(-50%, -50%, 0);
      text-transform: uppercase;
    }
  }
  & > .close {
    z-index: 15;
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    cursor: pointer;
    height: 3rem;
    width: 3rem;
    &:hover {
      &::after {
        color: black;
      }
    }
    &::after {
      color: #dadada;
      cursor: pointer;
      content: '\00d7';
      position: absolute;
      top: -0.3rem;
      right: -0rem;
      font-size: 1.25rem;
      //margin-top: -0.05rem;
      //transform: translate3d(0, -70%, 0);
    }
  }
  & > .minimize {
    z-index: 15;
    position: fixed;
    top: 5rem;
    right: 1.5rem;
    cursor: pointer;
    height: 3rem;
    width: 3rem;
    &:hover {
      &::after {
        color: black;
      }
    }
    &::after {
      display: inline-block;
      transform: rotate(-90deg);
      transform-origin: center;
      color: #dadada;
      cursor: pointer;
      content: '\00bb';
      position: absolute;
      top: -0.3rem;
      right: -0rem;
      font-size: 1.25rem;
      //margin-top: -0.05rem;
      //transform: translate3d(0, -70%, 0);
    }
  }
  & > .unminimize {
    z-index: 15;
    position: absolute;
    top: 79vh;
    right: 1.5rem;
    cursor: pointer;
    height: 3rem;
    width: 3rem;
    color: black;
    &:hover {
      &::after {
        color: black;
      }
    }
    &::after {
      display: inline-block;
      transform: rotate(90deg);
      transform-origin: center;
      color: #dadada;
      cursor: pointer;
      content: '\00bb';
      position: absolute;
      top: -0.3rem;
      right: -0rem;
      font-size: 1.25rem;
      //margin-top: -0.05rem;
      //transform: translate3d(0, -70%, 0);
    }
  }
  & > .ref-pub-opener {
    cursor: pointer;
    position: absolute;
    top: 0.5rem;
    right: 3.5rem;
    padding: 0.65rem 0.25rem 0.25rem 2.25rem;
    padding-bottom: 0.5rem;
    border: 1px solid #8a8a8a;
    border-radius: 0.25rem;
    z-index: 16;
    font-size: 0.7rem;
    text-transform: uppercase;
    font-family: Assistant, Roboto, sans-serif;
    .bg {
      background: no-repeat center;
      background-size: contain;
      position: absolute;
      top: 0.125rem;
      left: 0.25rem;
      width: 1.8rem;
      height: 1.8rem;
    }
  }
  & > .top {
    box-sizing: border-box;
    height: 4rem;
    padding: 0.5rem;
    & > .heading {
      text-align: left;
      font-size: 1.4rem;
      font-weight: 300;
      text-transform: uppercase;
      color: $brn;
      .custom {
        cursor: pointer;
        user-select: none;
        display: inline-block;
        margin-left: 4rem;
        transform: translate3d(0, -0.25rem, 0);
        box-sizing: border-box;
        width: 5rem;
        text-align: center;
        padding: 0.125rem 0.5rem;
        border: 1px solid #dadada;
        border-radius: 0.125rem;
        font-family: Assistant, Roboto, sans-serif;
        font-weight: 400;
        font-size: 0.7rem;
        text-transform: uppercase;
        color: $brn;
        background-color: white;
        transition: all 250ms ease-in-out;
        &.on {
          //font-weight: 600;
          //color: white;
          //background-color: $brn;
          border-color: orange;
        }
      }
    }
    & > .publishers {
      position: absolute;
      top: 0.5rem;
      right: 55rem;
      //width: 18rem;
      //display: flex;
      //grid-auto-columns: 20%;
      display: grid;
      //justify-content: flex-start;
      grid-template-columns: repeat(6, 1.5rem);
      grid-column-gap: 0.125rem;
      grid-row-gap: 1.5rem;
      box-sizing: border-box;
      padding: 0.5rem 0.5rem 1.5rem 5.25rem;
      pointer-events: none;
      opacity: 0;
      transition: all 250ms ease-in-out;
      max-height: 0;
      overflow: hidden;
      background-color: white;
      border: 1px solid transparent;
      border-radius: 0.25rem;
      &.has-overflow:hover {
        max-height: 100vh;
        border-color: #dadada;
      }
      &.shown {
        pointer-events: all;
        opacity: 1;
      }
      .title {
        cursor: default;
        position: absolute;
        top: 0.5rem;
        left: 0.25rem;
        color: $brn;
        text-transform: capitalize;
        font-family: Assistant, Roboto, sans-serif;
        font-weight: 400;
        font-size: 0.9rem;
        &[resetable] {
          cursor: pointer;
          &::after {
            content: '';
            position: absolute;
            bottom: 100%;
            left: 100%;
            transform: translate3d(-0.25rem, 0.25rem, 0);
            width: 0.3rem;
            height: 0.3rem;
            border-radius: 50%;
            background-color: orange;
          }
        }
      }
      &.has-selection {
        & > .publisher {
          &.on {
            opacity: 1;
            &::after {
              opacity: 1;
            }
          }
        }
      }
      & > .publisher {
        cursor: pointer;
        width: 1.25rem;
        height: 1.25rem;
        position: relative;
        //margin: 0 0.125rem;
        opacity: 0.5;
        &.on {
          opacity: 1;
          &::after {
            opacity: 0;
          }
        }
        &:hover {
          opacity: 1;
        }
        & > .bg {
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          background: white center no-repeat;
          background-size: contain;
        }
        &::after {
          content: '';
          position: absolute;
          top: 100%;
          left: 50%;
          transform: translate3d(-50%, 0.25rem, 0);
          width: 0.45rem;
          height: 0.45rem;
          background-color: orange;
          border-radius: 0.125rem;
          opacity: 0;
          transition: opacity 250ms ease-in-out;
        }
      }
    }
    & > .blocker {
      position: absolute;
      top: 0.75rem;
      right: 71rem;
      width: 5.5rem;
      height: 2rem;
      //background-color: orange;
    }
    & > .doc-types {
      position: absolute;
      top: 0.75rem;
      right: 71rem;
      width: 16.5rem;
      //display: flex;
      //grid-auto-columns: 20%;
      display: grid;
      //justify-content: flex-start;
      grid-template-columns: 15rem;
      //grid-template-columns: repeat(6, 1.5rem);
      grid-column-gap: 0.125rem;
      grid-row-gap: 1.5rem;
      box-sizing: border-box;
      pointer-events: none;
      opacity: 0;
      transition: all 250ms ease-in-out;
      max-height: 0;
      padding: 1.5rem 0.5rem 0 0.25rem;
      overflow: hidden;
      background-color: white;
      border: 1px solid transparent;
      border-radius: 0.25rem;
      //&.has-overflow:hover {
      &:hover {
        max-height: 100vh;
        border-color: #dadada;
        padding-bottom: 1.5rem;
        & > .doc-type {
          pointer-events: all;
          opacity: 0.5;
          &.on {
            opacity: 1;
          }
        }
      }
      &.shown {
        pointer-events: all;
        opacity: 1;
      }
      & > .title {
        cursor: default;
        position: absolute;
        top: 0.25rem;
        left: 0.25rem;
        color: $brn;
        text-transform: capitalize;
        font-family: Assistant, Roboto, sans-serif;
        font-weight: 400;
        font-size: 0.9rem;
        &[resetable] {
          cursor: pointer;
          &::after {
            content: '';
            position: absolute;
            bottom: 100%;
            left: 100%;
            transform: translate3d(-0.25rem, 0.25rem, 0);
            width: 0.3rem;
            height: 0.3rem;
            border-radius: 50%;
            background-color: orange;
          }
        }
      }
      &::after {
        position: absolute;
        top: 0.45rem;
        left: 5.5rem;
        content: 'all types';
        color: $brn;
        text-transform: uppercase;
        font-family: Assistant, Roboto, sans-serif;
        font-weight: 400;
        font-size: 0.7rem;
      }
      &.has-selection {
        &::after {
          content: attr(count) ' types selected';
        }
        &[count="1"]:after {
          content: '1 type selected';
        }
        &:hover {
          & > .doc-type {
            &.on {
              opacity: 1;
              &::after {
                opacity: 1;
              }
            }
          }
        }
      }
      & > .doc-type {
        cursor: pointer;
        position: relative;
        //margin: 0 0.125rem;
        opacity: 0;
        padding-left: 2rem;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: left;
        pointer-events: none;
        font-family: Assistant, Roboto, sans-serif;
        &.on {
          //opacity: 1;
          &::after {
            opacity: 0;
          }
        }
        &:hover {
          opacity: 1;
        }
        &::after {
          content: '';
          position: absolute;
          top: 50%;
          left: 1rem;
          transform: translate3d(0, -50%, 0);
          width: 0.45rem;
          height: 0.45rem;
          background-color: orange;
          border-radius: 0.125rem;
          opacity: 0;
          transition: opacity 250ms ease-in-out;
        }
      }
    }
  }
  & > .list {
    .items {
      //height: 100%;
      //overflow: auto;
      /*display: grid;*/
      /*row-gap: 0.25rem;*/
      //border-top: 1px solid orange;
      background-color: white;
      padding: 1.25rem 1.5rem 0;
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      grid-gap: 2rem;
      grid-auto-flow: row dense;
      transition: width 250ms ease-in-out;
      will-change: width;
      .item-wrap {
        display: block;
        text-decoration: inherit !important;
        color: inherit !important;
      }
      .item {
        border: 1px solid #efefef;
        position: relative;
        text-align: left;
        cursor: pointer;
        //height: auto;
        height: 8.5rem;
        padding: 0.5rem 3rem 1rem 3rem;
        &:hover {
          & > .date {
            opacity: 1;
          }
        }
        & > .text {
          position: relative;
          max-height: 9.5rem;
          overflow: auto;
          //background: linear-gradient(0, white, rgba(green, 0) 20%) no-repeat;
        }
        & > .publisher {
          position: absolute;
          bottom: 2.5rem;
          right: 0.5rem;
          & > .bg {
            width: 2rem;
            height: 2rem;
            background: center white no-repeat;
            background-size: contain;
          }
        }
        & > .document {
          position: absolute;
          top: -1rem;
          left: -1rem;
          padding: 0.125rem;
          border: 1px solid #ccc;
          & > .bg {
            width: 3rem;
            height: 4.25rem;
            background: center white no-repeat;
            background-size: contain;
          }
        }
        & > .date {
          pointer-events: none;
          position: absolute;
          bottom: 0.0625rem;
          right: 0.0625rem;
          padding: 0.125rem;
          background-color: rgba(255, 255, 255, 0.85);
          border-radius: 0.125rem;
          border: 1px solid #f9f9f9;
          font-size: 0.8rem;
          z-index: 4;
          opacity: 0;
          transition: opacity 250ms ease-in-out;
        }
      }
    }
  }
  & > .vis-types {
    padding: 1rem;
    display: grid;
    grid-template-columns: repeat(2, 5rem);
    grid-column-gap: 0.5rem;
    position: relative;
    .outline {
      position: absolute;
      top: calc(1rem - 1px);
      left: calc(1rem - 1px);
      width: 4.85rem;
      height: 1.16rem;
      pointer-events: none;
      border: 2px solid orange;
      border-radius: 0.125rem;
      transition: transform 150ms ease-in-out;
      will-change: transform;
      &.topThemes {
        transform: translate3d(5.5rem, 0, 0);
      }
    }
    .vis-type {
      cursor: default;
      box-sizing: border-box;
      padding: 0.125rem;
      text-align: center;
      border: 1px solid #dadada;
      border-radius: 0.125rem;
      text-transform: uppercase;
      font-size: 0.8rem;
      color: #8a8a8a;
      &.clickable:hover,
      &.on {
        cursor: pointer;
        border-color: $brn;
        color: $brn;
      }
      //&:first-of-type {
      //  border-top-left-radius: 0.25rem;
      //  border-bottom-left-radius: 0.25rem;
      //}
      //&:last-of-type {
      //  border-top-right-radius: 0.25rem;
      //  border-bottom-right-radius: 0.25rem;
      //}
    }
  }
  & > .top {
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    background: white;
    z-index: 8;
    padding-bottom: 0.5rem;
  }
  & > .themes {
    margin: 1rem;
    padding: 1.2rem;
    display: grid;
    grid-template-columns: repeat(40, 3.125rem);
    //grid-column-gap: 0.125rem;
    position: relative;
    padding-left: 5rem;
    padding-bottom: 1.5rem;
    max-width: 100vw;
    box-sizing: border-box;
    overflow: auto;
    &::before {
      content: 'themes:';
      position: absolute;
      top: 50%;
      left: 0;
      text-transform: capitalize;
      color: $brn;
      transform: translate3d(0, -50%, 0);
    }
    & > .theme {
      cursor: pointer;
      width: 3rem;
      flex: 0 0 auto;
      //border: 3px solid transparent;
      box-sizing: border-box;
      //padding-bottom: 0.5rem;
      padding: 0 0.25rem;
      //margin: 0.25rem;
      position: relative;
      transition: opacity 250ms ease-in-out;
      will-change: opacity;
      &:hover {
        .details {
          .label.top {
            opacity: 1;
            z-index: 1;
          }
          .close {
            opacity: 1;
          }
        }
      }
      &.dim {
        &:hover {
          opacity: 1;
        }
        opacity: 0.125;
      }
      &.on {
        .details {
          .label {
            opacity: 1;
            &.top {
              opacity: 0;
            }
          }
        }
      }
      .details {
        position: relative;
        .label {
          position: absolute;
          top: 100%;
          margin-top: 0.125rem;
          left: 50%;
          //width: 6rem;
          text-align: center;
          white-space: nowrap;
          padding: 0.125rem;
          background-color: white;
          transform: translate3d(-50%, 0, 0);
          color: $brn;
          opacity: 0;
          transition: opacity 250ms ease-in-out;
          will-change: opacity;
          &.top {
            top: -1.5rem;
          }
          //background-color: $brn
        }
        .close {
          position: absolute;
          top: -0.2rem;
          right: 0.125rem;
          color: white;
          text-shadow: 1px 1px 0 black, -1px -1px 0 black, 0 1px 0 black, 1px 0 0 black, 0 -1px 0 black,
          -1px 0 0 black, 1px 1px 1px black, -1px -1px 1px black, 0 1px 1px black, 1px 0 1px black,
          0 -1px 1px black, -1px 0 1px black;
          opacity: 0;
          transition: opacity 250ms ease-in-out;
          will-change: opacity;
        }
        .title {
          white-space: nowrap;
          overflow:  hidden;
          text-overflow: ellipsis;
        }
        .bg {
          width: 100%;
          padding-top: 145%;
          background: no-repeat top center;
          background-size: cover;
        }
      }
    }
  }
  .group {
    //min-height: 110vh;
    position: relative;
    &.has-pin {
      .by-theme {
        opacity: 0;
      }
    }
    .by-theme {
      background-color: white;
      border-bottom: 1px solid #ececec;
      padding-bottom: 0.5rem;
      margin: 0.75rem;
      margin-bottom: 1rem;
      &.pin {
        position: absolute;
        top: -0.8rem;
        left: 0;
        right: 0;
        z-index: 10;
        opacity: 1;
      }
      & > .top {
        position: sticky;
        top: 6.75rem;
        left: 0;
        right: 0;
        z-index: 6;
        //height: 5rem;
        background: white;
        box-shadow: 0 0 3px #ececec;
        padding-top: 0.75rem;
        padding-bottom: 0.5rem;
        & > .title {
          text-align: left;
          font-size: 1.7rem;
          padding-left: 0.5rem;
          margin-bottom: 0.5rem;
          transform-origin: left center;
          color: $brn;
          &.clickable {
            cursor: pointer;
          }
        }
      }
      &.has-hover {
        & > .top > .title {
          transition: all 200ms ease-in-out;
          transform-origin: left center;
          margin-bottom: -250%;
          transform: scale(0.5);
        }
        .rows {
          .row {
            transition: all 200ms ease-in-out;
            &.on {
              transform: none;
            }
            &:not(.on) {
              max-height: 0;
            }
          }
        }
      }
    }
  }
  .bar {
    display: grid;
    grid-template-columns: 1fr 12rem;
  }
  .leadingTrailing {
    display: grid;
    grid-template-columns: 4.5rem 4.5rem;
    margin-top: 2.5rem;
    height: 1.25rem;
    transition: opacity 250ms ease-in-out;
    will-change: opacity;
    &.hide {
      opacity: 0;
      pointer-events: none;
    }
    .leading,
    .trailing {
      text-transform: uppercase;
      font-size: 0.8rem;
      box-sizing: border-box;
      padding: 0.125rem 0.5rem;
      border: 1px solid transparent;
      border-radius: 0.125rem;
      cursor: pointer;
      transition: border-color 250ms ease-in-out;
      will-change: border-color;
      &.selected {
        cursor: default;
        border-color: orange;
      }
    }
  }
  .favicons {
    //position: sticky;
    //top: 0;
    //left: 0;
    //right: 0;
    overflow: auto;
    //background: white;
    //z-index: 7;
    margin: 1rem;
    display: grid;
    grid-template-columns: repeat(30, 2rem);
    grid-column-gap: 0.5rem;
    position: relative;
    padding: 1rem 1rem 1rem 5.75rem;
    &::before {
      content: 'companies:';
      text-transform: capitalize;
      position: absolute;
      top: 50%;
      left: 0;
      transform: translate3d(0, -50%, 0);
      color: $brn;
    }
  }
  .top {
    .times {
      position: absolute;
      top: 1rem;
      right: 14rem;
      display: flex;
      padding-left: 5.75rem;
      box-sizing: border-box;
      max-width: 100vw;
      grid-gap: 0.5rem;
      transition: opacity 250ms ease-in-out;
      pointer-events: none;
      opacity: 0;
      user-select: none;
      &.shown {
        opacity: 1;
        pointer-events: all;
      }
      .title {
        cursor: default;
        position: absolute;
        top: 0;
        left: 1rem;
        text-transform: capitalize;
        color: $brn;
        font-family: Assistant, Roboto, sans-serif;
        font-weight: 400;
        font-size: 0.9rem;
        &[resetable] {
          cursor: pointer;
          &::after {
            content: '';
            position: absolute;
            bottom: 100%;
            left: 100%;
            transform: translate3d(-0.25rem, 0.25rem, 0);
            width: 0.3rem;
            height: 0.3rem;
            border-radius: 50%;
            background-color: orange;
          }
        }
      }
      .range {
        position: absolute;
        top: -0.25rem;
        left: 0;
        margin-left: 5.75rem;
        bottom: -0.25rem;
        right: 0;
        margin-right: -0.65rem;
        background-color: rgba($brn, 0.08);
        //border-top: 1px solid $brn;
        .start, .end {
          position: absolute;
          top: 0;
          &.start {
            left: 0;
          }
          &.end {
            right: 0;
          }
          bottom: 0;
          width: 2px;
          background-color: rgba($brn, 0.25);
          //transition: all 250ms ease-in-out;
          cursor: ew-resize;
          z-index: 2;
          &.on {
            &::before {
              content: attr(start);
              position: absolute;
              top: 100%;
              left: 50%;
              transform: translate3d(-50%, 100%, 0);
              font-size: 0.75rem;
              color: $brn;
            }
          }
          &.on,
          &:hover {
            background-color: $brn;
            &::after {
              border-color: $brn;
            }
          }
          &::after {
            content: '';
            position: absolute;
            top: 100%;
            left: 50%;
            transform: translate3d(-50%, 0, 0);
            width: 0.6rem;
            height: 0.55rem;
            background-color: white;
            border: 2px solid rgba($brn, 0.25);
            border-radius: 100%;
            font-size: 0.1rem;
            //transition: background-color 250ms ease-in-out;
          }
        }
      }
      .time {
        width: auto;
        box-sizing: border-box;
        //margin: 0 0.5rem;
        font-size: 0.75rem;
        color: $brn;
        padding: 0.125rem 0.5rem;
        border: 1px solid transparent;
        border-radius: 0.25rem;
        transition: all 250ms ease-in-out;
        cursor: default;
        &.on {
          color: white;
          background-color: $brn;
        }
        &.skinny {
          color: transparent;
          background-color: rgba($brn, 0.25);
          width: 1px;
          border-color: transparent;
          height: 0.6rem;
          margin-top: 0.4rem;
          padding: 0;
        }
      }
      .links {
        z-index: 1;
        .link {
          cursor: pointer;
          position: absolute;
          bottom: -0.85rem;
          //left: 10rem;
          width: 0.25rem;
          height: 0.25rem;
          border: 1px solid #ccc;
          border-radius: 50%;
          &:hover {
            .label {
              opacity: 1;
            }
          }
          .label {
            position: absolute;
            top: 100%;
            left: 50%;
            transform: translate3d(-50%, 0.125rem, 0);
            color: $brn;
            text-transform: uppercase;
            font-size: 0.75rem;
            white-space: nowrap;
            opacity: 0;
            transition: opacity 250ms ease-in-out;
          }
        }
      }
    }
  }
  .rows {
    position: relative;
    //transform: translate3d(0, 1.5rem, 0) scale(1.5);
    transform-origin: left center;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    .row {
      position: relative;
      //position: absolute;
      top: 0;
      left: 0;
      right: 0;
      margin-bottom: 0.125rem;
      overflow: hidden;
      transition: transform 250ms ease-in-out;
      max-height: 2rem;
      padding-left: 1.5rem;
      &:hover {
        .favicon {
          .label {
            opacity: 1;
          }
        }
      }
      .favicon {
        z-index: 3;
        &:hover {
          & > .label {
            //opacity: 0.8;
          }
        }
        & > .label {
          position: absolute;
          top: 50%;
          left: 0;
          transform: translate3d(2.5rem, -50%, 0);
          pointer-events: all;
          padding: 0.125rem 0.5rem;
          background-color: $brn;
          color: white;
          border-radius: 0.25rem;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 5.5rem;
          z-index: 5;
          //border: 1px solid #ccc;
          //box-shadow: 0 0 1px #cecece;
        }
      }
      .dashes {
        height: 1px;
        width: 1px;
        position: relative;
        top: -1rem;
        &::before {
          content: '';
          position: absolute;
          top: 50%;
          right: 100%;
          font-size: 1px;
          border-top: 2px dashed rgba($brn, 0.25);
          transform: translate3d(-0.75rem, -1px, 0);
          width: 100vw;
        }
      }
      & > .history > .past {
        position: absolute;
        top: 0.5rem;
        left: 0;
        font-size: 0.6rem;
        z-index: 2;
        background-color: white;
        padding: 0.125rem;
        padding-right: 0.35rem;
        border-radius: 0.125rem;
        border-top-right-radius: 100%;
        border-bottom-right-radius: 100%;
        cursor: default;
        border: 1px solid rgba($brn, 0.25);
        color: $brn;
        pointer-events: all;
        transition: all 250ms ease-in-out;
        transform-origin: center;
        &.on {
          background-color: $brn;
          color: white;
          z-index: 4;
        }
        &[rsp='one'] {
          border-color: rgba($brn, 0.5);
          &.on {
            background-color: rgba($brn, 0.5);
          }
        }
        &[rsp='two'] {
          border-color: $brn;
          &.on {
            background-color: rgba($brn, 0.5);
          }
        }
        &[rsp='three'],
        &[rsp='four'],
        &[rsp='five'] {
          border-color: $brn;
          box-shadow: -1px 0 2px rgba($brn, 0.5);
          &.on {
            background-color: $brn;
          }
        }
        &[rsp='four'] {
          box-shadow: -1px 0 3px rgba($brn, 0.5),
          -3px 0 1px rgba($brn, 0.5);
        }
        &[rsp='five'] {
          box-shadow: -1px 0 4px rgba($brn, 0.5),
          -3px 0 1px rgba($brn, 0.5),
          -6px 0 1px rgba($brn, 0.75);
        }
        &:last-of-type {
          display: none;
        }
      }
    }
  }
  .favicon {
    width: 2rem;
    height: 2rem;
    background: no-repeat center;
    background-size: contain;
    position: relative;
    &.dim {
      &:hover {
        opacity: 1;
      }
      opacity: 0.125;
    }
    //&.total {
    //  background-image: url('https://www.total.com/themes/custom/total_com/dist/img/favicon.png');
    //}
    //&.bp {
    //  background-image: url('https://www.bp.com/etc/designs/refresh/bp/favicon.ico');
    //}
    //&.chevron {
    //  background-image: url('https://www.chevron.com/assets/fav/favicon.ico?v=7k4MjPGMX6');
    //}
    //&.shell {
    //  background-image: url('https://www.shell.com/apps/settings/wcm/designs/shell-rio/clientlibs/themes/theme-shell/resources/favicon/favicon.ico');
    //}
    //&.exxon {
    //  background-image: url('https://corporate.exxonmobil.com/-/media/Global/Icons/XX-favicon.ico');
    //}
    //&.aramco {
    //  background-image: url('https://americas.aramco.com/images/favicon/favicon.ico');
    //}
    //&.cnpc {
    //  background-image: url('https://www.cnpc.com.cn/favicon.ico');
    //}
    &:hover > .label {
      opacity: 1;
    }
    & > .label {
      position: absolute;
      top: 100%;
      left: 50%;
      transform: translate3d(-50%, 0.25rem, 0);
      white-space: nowrap;
      text-transform: uppercase;
      font-size: 0.8rem;
      color: $brn;
      opacity: 0;
      transition: opacity 250ms ease-in-out;
      will-change: opacity;
      pointer-events: none;
    }
  }
}
</style>
<style lang="scss">
@import '../../scss/global';
.robo-report {
  .items {
    position: relative;
    .item {
      .text {
        .keyword {
          color: $brn;
        }
      }
      .copy {
        position: absolute;
        top: -1.25rem;
        right: 0.5rem;
        .paper {
          opacity: 0;
        }
      }
      &:hover .copy {
        .paper {
          opacity: 0.35;
        }
        .angles {
          opacity: 1;
        }
      }
    }
  }
}
</style>
